<template>
    <div>
        <div class="d-flex">
            <div class="col-6">
                <v-card :class="singleMod === undefined ? 'p-0 elevation-0' : 'p-4'">
                    <div class="p-3 card-text">
                        <div @mouseover="setBubblePos(45, 0)">
                            <v-text-field
                                background-color="white"
                                label="Nom de votre structure"
                                prepend-icon="subject"
                                @input="updateOrganism"
                                v-model="organismValue"
                                outlined
                            >
                                <template
                                    v-slot:append
                                    v-if="account.configurations.organism !== null"
                                >
                                    <v-fade-transition leave-absolute>
                                        <v-icon color="success">check</v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>
                        </div>

                        <div
                            @mouseover="setBubblePos(130, 1)"
                            style="min-height: 120px"
                        >
                            <v-file-input
                                label="Conditions Générales d'Utilisation"
                                outlined
                                dense
                                @change="saveCgu"
                                @mouseover="setBubblePos(180)"
                                v-model="cguFile"
                                :rules="rules"
                                accept="application/pdf"
                            >
                                <template
                                    v-slot:append
                                    v-if="account.configurations.cgu !== null"
                                >
                                    <v-fade-transition leave-absolute>
                                        <v-icon color="success">check</v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-file-input>

                            <div class="mb-5">
                                <a
                                    :href="account.configurations.cgu.doc_url"
                                    target="_blank"
                                    v-if="account.configurations.cgu !== null"
                                    class="config-link"
                                >
                                    Voir mes CGU
                                </a>
                            </div>
                        </div>

                        <div
                            @mouseover="setBubblePos(250, 2)"
                            style="min-height: 120px"
                            v-if="isCampaignAvailable('CADH')"
                        >
                            <v-file-input
                                label="Conditions Générales de Ventes"
                                outlined
                                dense
                                @change="saveCguCadh"
                                @mouseover="setBubblePos(180)"
                                v-model="cguCadhFile"
                                :rules="rules"
                                accept="application/pdf"
                            >
                                <template
                                    v-slot:append
                                    v-if="account.configurations.cguCadh !== null"
                                >
                                    <v-fade-transition leave-absolute>
                                        <v-icon color="success">check</v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-file-input>

                            <div class="mb-5">
                                <a
                                    :href="account.configurations.cguCadh.doc_url"
                                    target="_blank"
                                    v-if="account.configurations.cguCadh !== null"
                                    class="config-link"
                                >
                                    Voir mes CGV
                                </a>
                            </div>
                        </div>

                        <div @mouseover="setBubblePos(isCampaignAvailable('CADH') ? 370 : 250, 3)">
                            <v-file-input
                                label="Logo"
                                outlined
                                @change="saveLogo"
                                dense
                                v-model="logoFile"
                                accept="image/*"
                            >
                                <template
                                    v-slot:append
                                    v-if="account.configurations.logo !== null"
                                >
                                    <v-fade-transition leave-absolute>
                                        <v-icon color="success">check</v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-file-input>
                        </div>

                        <div class="mb-5">
                            <a
                                :href="account.configurations.logo.doc_url"
                                target="_blank"
                                v-if="account.configurations.logo !== null"
                                class="config-link"
                            >
                                Voir mon logo
                            </a>
                        </div>

                        <div
                            v-if="uskaContract"
                            @mouseover="setBubblePos(isCampaignAvailable('CADH') ? 500 : 380, 4)"
                        >
                            <v-file-input
                                label="Logo carré"
                                outlined
                                @change="saveSquaredLogo"
                                dense
                                v-model="squaredLogoFile"
                                accept="image/*"
                            >
                                <template
                                    v-slot:append
                                    v-if="account.configurations.uskaLogo !== null"
                                >
                                    <v-fade-transition leave-absolute>
                                        <v-icon color="success">check</v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-file-input>
                        </div>

                        <div
                            v-if="uskaContract"
                            class="mb-5"
                        >
                            <a
                                :href="account.configurations.uskaLogo.doc_url"
                                target="_blank"
                                v-if="account.configurations.uskaLogo !== null"
                                class="config-link"
                            >
                                Voir mon logo carré
                            </a>
                        </div>
                    </div>
                </v-card>
            </div>

            <div class="col-6">
                <talk-bubble :top="bubblePos">
                    <slot>
                        <organism-field v-if="fieldIndex === 0"></organism-field>
                        <cgu-field v-if="fieldIndex === 1"></cgu-field>
                        <cguCadh-field v-if="fieldIndex === 2"></cguCadh-field>
                        <logo-field v-if="fieldIndex === 3"></logo-field>
                        <squared-logo-field v-if="fieldIndex === 4"></squared-logo-field>
                    </slot>
                </talk-bubble>
            </div>
        </div>

        <div
            class="text-right mb-3 mt-5"
            v-if="singleMod === undefined"
        >
            <v-btn
                class="default-button mt-3"
                @click="nextStep"
            >
                Passer à l'étape suivante
            </v-btn>
        </div>
    </div>
</template>

<script>
import TalkBubble from "../../tools/TalkBubble"
import OrganismField from "../../tools/contents/OrganismField"
import CguField from "../../tools/contents/CguField"
import CguCadhField from "../../tools/contents/CguCadhField"
import LogoField from "../../tools/contents/LogoField"
import SquaredLogoField from "../../tools/contents/SquaredLogoField.vue"
import {mapMutations, mapState} from "vuex"
import _ from "lodash"

export default {
    name: "Organism",
    props: ["singleMod"],
    components: {LogoField, SquaredLogoField, CguField, CguCadhField, OrganismField, TalkBubble},
    data() {
        return {
            cguFile: null,
            cguCadhFile: null,
            logoFile: null,
            squaredLogoFile: null,
            bubblePos: 18,
            fieldIndex: 0,
            organismValue: null,
            rules: [
                (value) =>
                    !value || value.name.substr(value.name.length - 3) === "pdf" || value.size < 2000000 ||
                  "Le fichier doit être au format .pdf et ne pas faire plus de 2 MB",
            ],
        }
    },
    methods: {
        ...mapMutations("account", ["setOrganism", "setLogo", "setCgu", "setCguCadh"]),
        updateOrganism: _.debounce(function () {
            if (this.organismValue !== null && this.organismValue !== "") {
                let payload = {
                    organism: this.organismValue,
                }

                this.$global.loading = true

                this.$http.post("auth/onboarding/steps/organism", payload).then(() => {
                    this.$global.loading = false
                })
            }
        }, 1000),
        setPayload(key, value, payload) {
            if (value !== null) {
                payload.set(key, value)
            }
        },
        setBubblePos(top, fieldIndex) {
            this.bubblePos = top
            this.fieldIndex = fieldIndex
        },
        saveCgu() {
            if (this.cguFile !== null) {
                let payload = new FormData()

                if (this.cguFile.name.substr(this.cguFile.name.length - 3) === "pdf") {
                    this.setPayload("cgu", this.cguFile, payload)

                    this.$global.loading = true

                    this.$http.post("auth/onboarding/steps/cgu", payload).then((res) => {
                        this.cguFile = null

                        this.account.configurations.cgu = res.body.data.cgu

                        this.$global.loading = false
                    })
                }
            }
        },
        saveCguCadh() {
            if (this.cguCadhFile !== null) {
                let payload = new FormData()

                if (this.cguCadhFile.name.substr(this.cguCadhFile.name.length - 3) === "pdf") {
                    this.setPayload("cguCadh", this.cguCadhFile, payload)

                    this.$global.loading = true

                    this.$http.post("auth/onboarding/steps/cguCadh", payload).then((res) => {
                        this.cguCadhFile = null

                        this.account.configurations.cguCadh = res.body.data.cgu

                        this.$global.loading = false
                    })
                }
            }
        },
        saveLogo() {
            if (this.logoFile !== null) {
                let payload = new FormData()

                this.setPayload("logo", this.logoFile, payload)

                this.$global.loading = true

                this.$http.post("auth/onboarding/steps/logo", payload).then((res) => {
                    this.logoFile = null

                    this.account.configurations.logo = res.body.data.logo

                    this.$global.loading = false
                })
            }
        },

        saveSquaredLogo() {
            if (this.squaredLogoFile !== null) {
                let payload = new FormData()

                this.setPayload("logo", this.squaredLogoFile, payload)

                this.$global.loading = true

                this.$http.post("auth/onboarding/steps/uska-logo", payload).then((res) => {
                    this.squaredLogoFile = null

                    this.account.configurations.uskaLogo = res.body.data.logo

                    this.$global.loading = false
                })
            }
        },

        nextStep() {
            this.$global.$emit("change-step", 2)
        },
        isCampaignAvailable(code) {
            let available = false
            let contracts = this.account.current_contracts

            if (contracts.length) {
                contracts.forEach(contract => {
                    let module = contract.contract_offer.options.filter(option => option.code === code)

                    if (module.length) {
                        available = true
                    }
                })
            }
            return available
        },
    },

    computed: {
        ...mapState("account", ["account", 'uskaContract'])
    },

    created() {
        this.organismValue =
            this.account.configurations.organism !== null ? this.account.configurations.organism.value : null
    },
}
</script>
